// extracted by mini-css-extract-plugin
export default {"terminalBtn":"TerminalNav_terminalBtn__Gd68X"};